import store from './store';

const stores = {
  store,
};

export default stores;
